// src/components/Header.js
import React from 'react';
import { Link } from 'react-router-dom';

const Header = ({ cartItemsCount = 0, onCartToggle }) => {
  return (
    <header className="sticky top-0 z-40 shadow-sm" style={{ backgroundColor: 'var(--surface-color)' }}>
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 md:px-6">
        <div className="flex items-center gap-8">
          <Link to="/" className="flex items-center gap-2 no-underline">
            <img
              src="logo.png"
              alt="CrokChef Logo"
              className="logo"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.parentElement.innerHTML = `
                  <span style="color: var(--primary-color); font-size: 28px;">🍔</span>
                `;
              }}
            />
          </Link>
          <div className="hidden md:flex gap-6 font-semibold">
            <a href="#menu" className="no-underline transition-colors hover:text-[var(--primary-color)]" style={{ color: 'var(--text-color)' }}>
              Menú
            </a>
            <Link
              to="/politica-privacidad"
              className="no-underline transition-colors hover:text-[var(--primary-color)]"
              style={{ color: 'var(--text-color)' }}
            >
              Privacidad
            </Link>
          </div>
        </div>
        <div className="flex items-center gap-4">
          <button
            className="btn btn-ghost btn-circle relative"
            onClick={onCartToggle}
            aria-label="Abrir carrito de compras"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" className="w-5 h-5">
              <path
                fill="currentColor"
                d="M0 24C0 10.7 10.7 0 24 0L69.5 0c22 0 41.5 12.8 50.6 32l411 0c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3l-288.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5L488 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
              />
            </svg>
            {cartItemsCount > 0 && (
              <span
                className="badge badge-sm absolute -top-1 -right-1 border-none font-bold"
                style={{ backgroundColor: 'var(--secondary-color)', color: 'black' }}
              >
                {cartItemsCount}
              </span>
            )}
          </button>
        </div>
      </nav>
    </header>
  );
};

export default Header;